import type { ReactNode } from 'react'

import { ErrorMessage } from '@/src/general/components/ErrorMessage'

import { useConversationContact } from '../../../../services/useConversationContact'
import { useSingleConversationQuery } from '../../../../services/useSingleConversationQuery'
import { SingleConversation } from '../../../components/SingleConversation'
import { ConversationHeaderLayout } from './ConversationHeaderLayout'
import { ConversationPlaceholder } from './ConversationPlaceholder'

export const ExistingConversation = ({
  conversationId,
  openedConversationId,
}: {
  conversationId: number
  openedConversationId: number | undefined
}): ReactNode => {
  const { data: conversation, error } = useSingleConversationQuery(conversationId)
  const conversationContact = useConversationContact(conversation?.conversationUsers)

  return (
    <ConversationHeaderLayout
      user={conversationContact}
      conversation={conversation}
      openedConversationId={openedConversationId}
    >
      {conversation && <SingleConversation conversation={conversation} />}
      {!conversation && error && <ErrorMessage defaultErrorKey="contact.load.error" error={error} />}
      {!conversation && !error && <ConversationPlaceholder />}
    </ConversationHeaderLayout>
  )
}
